export const Routes = {
  MY_ORDERS: '/my-orders',
  FEEDBACK: '/feedback',
  NEW_FEEDBACK: '/my-orders/feedback/:country/:resourceId/:surveyId',
};
